import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout = ({
  children
}: LayoutProps) => {
  const [collapsed, setCollapsed] = useState(false);
  return <div className="flex h-screen w-full bg-gray-100" data-id="element-1284">
      <Sidebar collapsed={collapsed} data-id="element-1285" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1286">
        <Header onToggleSidebar={() => setCollapsed(!collapsed)} data-id="element-1287" />
        <main className="flex-1 overflow-auto p-6 bg-gray-100" data-id="element-1288">{children}</main>
      </div>
    </div>;
};